import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { parseQueryParams } from 'utils/url';

import { DEALER_QUERY_STRING_PARAM } from './constants';

/**
 * HOC to provide the current search parameter for a dealer search, as
 * found in the current URL query string.
 *
 * The search value is provided to the wrapped component as a
 * prop named `currentSearchParam`.
 */
export default function withSearchUrlParam(WrappedComponent) {
  function WithSearchQuery(props) {
    const { location } = props;
    const queryParams = parseQueryParams(location.search);
    const currentParam = queryParams[DEALER_QUERY_STRING_PARAM] || '';
    return <WrappedComponent {...props} currentSearchParam={currentParam} />;
  }

  WithSearchQuery.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
  };

  return withRouter(WithSearchQuery);
}



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerSearch/withSearchUrlParam.js